import { ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useWealth } from '../../../api';
import { AssetsLiabilitiesChart } from './assets/AssetLiabilitiesChart';
import { EmptyChartMessage } from './EmptyChartMessage';

export const TotalWealthCharts: FunctionComponent = () => {
    const { assetsTotal } = useWealth();

    if (!assetsTotal) return <EmptyChartMessage />;

    return (
        <ZfStack direction="row" spacing="extra-extra-large" alignment="center" justify="center" style={{ flexGrow: 1 }}>
            <AssetsLiabilitiesChart floatLegend={false} legendPosition={'left'} showNetAmount={true} width={825} legendWith={300} accountType="ASSET" />
            <AssetsLiabilitiesChart floatLegend={false} legendPosition={'right'} showNetAmount={true} width={825} legendWith={300} accountType="LIABILITY" />
        </ZfStack>
    );
};
